import { defineComponent as _defineComponent } from 'vue'
import HumanResourcesApi from '@/modules/adminPanel/services/HumanResourcesApi';
import { QuizTest, QuizTestAttempt } from '@/modules/bhp/models/QuizTest';
import { onMounted, ref } from 'vue';
import { QuizCategory } from '@/models/Quiz';
import QuizCard from '@/modules/Statements/components/QuizCard.vue';
import AuthService from '@/modules/user/AuthService';
import QuizCardSuccess from '@/modules/Statements/components/QuizCardSuccess.vue';
import { useInstance } from '@/composables/useInstance';
import { useModal } from '@/components/L/Modal/useModal';
import NavigationHeader from '@/components/NavigationHeader/NavigationHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuizzesView',
  setup(__props) {

const loading = ref<boolean>(false);
const quizzes = ref<QuizTest[]>([]);
const lastPositiveAttempt = ref<Nullable<QuizTestAttempt>>(null);
const { $route, $modalService, $router } = useInstance();
const {openModal,} = useModal();

const getLatestResultsForCurrentUser = async () => {
  try {
    loading.value = true;
    const result = await HumanResourcesApi.getLatestResultForCurrentUser(QuizCategory.ETHIC);
    if (result) {
      lastPositiveAttempt.value = result;
    }
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};

const getNewestQuizTestQuestions = async () => {
  try {
    const quiz = await HumanResourcesApi.getNewestQuizTestQuestions(QuizCategory.ETHIC);
    quizzes.value = quiz ? [quiz] : [];
  } catch (e) {
    console.error(e);
  }
};


onMounted(async () => {
  await getLatestResultsForCurrentUser();
  await getNewestQuizTestQuestions();
  
  if ($route.value?.query.ethic) {
      $router.value?.push({query: {ethic: undefined,},})
    if (lastPositiveAttempt.value) {
      await openModal(QuizCardSuccess, {
        lastPositiveAttempt: lastPositiveAttempt.value!,
        quizCategory: QuizCategory.ETHIC
      });
    }
  }
});

return { __sfc: true,loading, quizzes, lastPositiveAttempt, $route, $modalService, $router, openModal, getLatestResultsForCurrentUser, getNewestQuizTestQuestions, QuizCategory, QuizCard, AuthService, NavigationHeader }
}

})